export default [
	{
		path: '/manage/shopServe',
		component: (resolve) => require(['../index.vue'], resolve),
		meta: {
			title: '门店服务',
			keepAlive: false,
		},
  },
  {
		path: '/manage/shopServeed',
		component: (resolve) => require(['../page.vue'], resolve),
		meta: {
			title: '门店服务',
			keepAlive: false,
		},
  },
  {
		path: '/manage/smsSendTotal',
		component: (resolve) => require(['../smsSendTotal.vue'], resolve),
		meta: {
			title: '缴费记录',
			keepAlive: false,
		},
  },
  {
		path: '/manage/smsSendDetail',
		component: (resolve) => require(['../smsSendDetail.vue'], resolve),
		meta: {
			title: '缴费记录',
			keepAlive: false,
		},
	},
	{
		path: '/manage/paymentRecord',
		component: (resolve) => require(['../paymentRecords.vue'], resolve),
		meta: {
			title: '缴费记录',
			keepAlive: false,
		},
	},
]
